import { inject } from "@angular/core";
import { Router, type CanActivateFn, type UrlTree } from "@angular/router";

import { AuthStateService } from "../services/auth-state.service";

/**
 * Keeps a customer with a temporary password out of the portal until they
 * choose their own (branded-login DECISION-009). Runs after authGuard, so the
 * visitor is known to be signed in.
 *
 * A UI affordance: the password an admin issued is the one they are holding,
 * and the API does not refuse other requests while the flag is set.
 */
export const passwordChangeGuard: CanActivateFn = (): boolean | UrlTree => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  return authState.mustChangePassword() ? router.createUrlTree(["/set-password"]) : true;
};

/**
 * The /set-password page itself: only for someone who has a password to
 * replace. Anyone else is sent into the portal, so the page cannot be reached
 * by a stale link after the change.
 */
export const setPasswordPageGuard: CanActivateFn = (): boolean | UrlTree => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  if (!authState.isAuthenticated()) {
    return router.createUrlTree(["/login"]);
  }

  return authState.mustChangePassword() ? true : router.createUrlTree(["/"]);
};
